// extracted by mini-css-extract-plugin
export default {"layout":"styles_layout__tufWr","header":"styles_header__YosUm","logo":"styles_logo__10rQ2","content":"styles_content__QdsOH","avatar":"styles_avatar__ZOBZ1"};